const pageNameKey = "otaDownloadModal";

export const otaDownloadModalEn = {
  [pageNameKey]: {
    modalTitle: "Downloading package...",
    backgroundTitle: "Downloading package in the background",
    backgroundDescription:
      "The package is currently downloading in the background. You can safely close this window.",
    zipInfoText: "Once downloaded, the file can be opened with any ZIP tool.",
    notificationText:
      "You will receive a browser notification when the download is complete.",
    closeButtonText: "Close",
  },
};

export const otaDownloadModalPtBr = {
  [pageNameKey]: {
    modalTitle: "Baixando pacote...",
    backgroundTitle: "Baixando pacote em segundo plano",
    backgroundDescription:
      "O pacote está sendo baixado em segundo plano. Você pode fechar esta janela com segurança.",
    zipInfoText:
      "Após o download, o arquivo pode ser aberto com qualquer ferramenta ZIP.",
    notificationText:
      "Você receberá uma notificação do navegador quando o download for concluído.",
    closeButtonText: "Close",
  },
};

export const otaDownloadModalDe = {
  [pageNameKey]: {
    modalTitle: "Paket wird heruntergeladen...",
    backgroundTitle: "Paket wird im Hintergrund heruntergeladen",
    backgroundDescription:
      "Das Paket wird derzeit im Hintergrund heruntergeladen. Sie können dieses Fenster sicher schließen.",
    zipInfoText:
      "Nach dem Download kann die Datei mit jedem ZIP-Tool geöffnet werden.",
    notificationText:
      "Sie erhalten eine Browser-Benachrichtigung, sobald der Download abgeschlossen ist.",
    closeButtonText: "Close",
  },
};

export const otaDownloadModalZhHans = {
  [pageNameKey]: {
    modalTitle: "正在下载软件包...",
    backgroundTitle: "正在后台下载软件包",
    backgroundDescription: "该软件包当前正在后台下载。您可以安全地关闭此窗口。",
    zipInfoText: "下载完成后，可使用任何 ZIP 工具打开该文件。",
    notificationText: "下载完成后，您将收到浏览器通知。",
    closeButtonText: "Close",
  },
};

export const otaDownloadModalIt = {
  [pageNameKey]: {
    modalTitle: "Download del pacchetto in corso...",
    backgroundTitle: "Download del pacchetto in background",
    backgroundDescription:
      "Il pacchetto è attualmente in download in background. Puoi chiudere questa finestra in sicurezza.",
    zipInfoText:
      "Una volta scaricato, il file può essere aperto con qualsiasi strumento ZIP.",
    notificationText:
      "Riceverai una notifica del browser quando il download sarà completato.",
    closeButtonText: "Close",
  },
};

export const otaDownloadModalEs = {
  [pageNameKey]: {
    modalTitle: "Descargando paquete...",
    backgroundTitle: "Descargando paquete en segundo plano",
    backgroundDescription:
      "El paquete se está descargando actualmente en segundo plano. Puede cerrar esta ventana con seguridad.",
    zipInfoText:
      "Una vez descargado, el archivo puede abrirse con cualquier herramienta ZIP.",
    notificationText:
      "Recibirá una notificación del navegador cuando se complete la descarga.",
    closeButtonText: "Cerrar",
  },
};

export const otaDownloadModalNl = {
  [pageNameKey]: {
    modalTitle: "Pakket wordt gedownload...",
    backgroundTitle: "Pakket wordt op de achtergrond gedownload",
    backgroundDescription:
      "Het pakket wordt momenteel op de achtergrond gedownload. U kunt dit venster veilig sluiten.",
    zipInfoText:
      "Na het downloaden kan het bestand met elke ZIP-tool worden geopend.",
    notificationText:
      "U ontvangt een browsermelding wanneer de download is voltooid.",
    closeButtonText: "Close",
  },
};

export const otaDownloadModalTr = {
  [pageNameKey]: {
    backgroundDescription:
      "Paket şu anda arka planda indiriliyor. Bu pencereyi güvenle kapatabilirsiniz.",
    backgroundTitle: "Arka planda paket indiriliyor",
    closeButtonText: "Kapat",
    modalTitle: "Paket indiriliyor...",
    notificationText:
      "İndirme işlemi tamamlandığında bir tarayıcı bildirimi alacaksınız.",
    zipInfoText:
      "Dosya indirildikten sonra herhangi bir ZIP aracıyla açılabilir.",
  },
};
